<form
  [formGroup]="formGroup"
  class="swd-form-group">
  <div class="swd-form-control">
    <label
      [class.ng-invalid]="isInvalid('name')"
      for="name"
      class="swd-form-label">
      {{ 'startWorkDoneList.description' | translate }}
    </label>
    <textarea
      [placeholder]="'app.forms.labels.placeHolderDescription' | translate"
      formControlName="name"
      id="name"
      rows="5"
      pTextarea
      class="swd-textarea"></textarea>
  </div>

  <div class="swd-form-actions swd-form-actions--right">
    <button
      (click)="cancel()"
      class="swd-button secondary">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      [disabled]="!formGroup.valid"
      (click)="onSave()"
      class="swd-button primary">
      {{ 'common.save' | translate }}
    </button>
  </div>
</form>
